<div class="calendar-error-side-panel" [attr.data-test]="'calendar-errors-side-panel'">
	<div class="panel-header">
		<h2 class="panel-title" [attr.data-test]="'calendar-errors-side-panel-header'">CALENDAR ERRORS</h2>
		<button class="close-button" type="button" aria-label="Close" (click)="closePanel()">
			<app-icon
				[name]="'close'"
				[color]="'var(--color-text-default)'"
				[size]="'40'"
				[lineWidth]="'1px'"
			></app-icon>
		</button>
	</div>

	<div class="tab-list" role="tablist" aria-label="Calendar errors tabs">
		@for (tab of tabs; track tab; let tabIndex = $index) {
		<button
			class="tab-item"
			type="button"
			[class.active]="activeTabIndex === tabIndex"
			[attr.aria-selected]="activeTabIndex === tabIndex"
			(click)="selectedTab(tabIndex)"
			[attr.data-test]="'tab-item-' + tabIndex"
		>
			{{ tab }}
		</button>
		}
	</div>

	<div class="search-box" [attr.data-test]="'calendar-errors-side-panel-search-box'">
		<app-icon [name]="'search-normal-1'" [size]="'24'" [color]="'var(--color-search-icon)'"></app-icon>
		<input
			type="text"
			placeholder="Search by..."
			[value]="searchText"
			(input)="searchText = $any($event.target).value"
			[attr.data-test]="'calendar-errors-side-panel-search-box-input'"
		/>
	</div>

	<div class="calendar-error-list" [attr.data-test]="'calendar-errors-side-panel-error-list'">
		@for (item of filteredCalendarErrorRecordsItems; track item.createdAt) {
		<div class="calendar-error-item" [attr.data-test]="'calendar-errors-side-panel-error-item'">
			<div class="calendar-error-item-log">
				<span class="item-log-time" [attr.data-test]="'calendar-errors-side-panel-error-item-log-time'"
					>{{ item.createdAt | date : "HH:mm" }} {{ item.createdAt | date }}</span
				>
				<span class="item-log-type" [attr.data-test]="'calendar-errors-side-panel-error-item-log-type'">{{
					item.errorType
				}}</span>
			</div>

			<div class="calendar-error-item-content" [attr.data-test]="'calendar-errors-side-panel-error-item-content'">
				<h3 class="item-title" [attr.data-test]="'calendar-errors-side-panel-error-item-title'">
					{{ item.title }}
				</h3>
				<p class="item-subtitle" [attr.data-test]="'calendar-errors-side-panel-error-item-subtitle'">
					<img class="item-flag" src="assets/svg-country-flags/svg/{{ item.flag?.toLowerCase() }}.svg" />
					{{ item.subtitle }}
				</p>
				<p class="item-description" [attr.data-test]="'calendar-errors-side-panel-error-item-description'">
					{{ item.errorDescription }}
				</p>
				@if (item.hasCalendarLink) {
				<button
					class="item-link"
					type="button"
					(click)="goToCalendar(item.payGroupId!, item.legalEntityId!, item.customerName!, item.customerId!)"
					[attr.data-test]="'calendar-errors-side-panel-error-item-link'"
				>
					Go to Calendar <span aria-hidden="true">→</span>
				</button>
				}
			</div>
		</div>
		}
	</div>
	@if (filteredCalendarErrorRecordsItems.length === 0) {
	<no-items-layout message="No records to display"></no-items-layout>
	}
</div>
